import React from 'react';
import { Dropdown, Checkbox } from 'semantic-ui-react';

class MultiDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.func = this.func.bind(this);
        this.state= {
            isOpen: false,
            last: true,
        };
    }
    func(event, data){
        this.state.last2 = true;
        if(data.id === 'item'){
            this.setState({
                isOpen: true,
                last2: false
            });
            this.state.last = true;
            
        }
        else{
            if (!this.state.last || !this.state.isOpen){
                this.setState({
                    isOpen: !this.state.isOpen,
                });
            }
            this.state.last =false;
        }
    }
     

    render(){
        return(
            <Dropdown
                
                className='icon'
                id="d0"
                selection
                fluid
                open = {this.state.isOpen}
                text = {this.props.name}
                onClick = {this.func}
            >
                <Dropdown.Menu >
                    {
                        this.props.options.map((s)=>(
                            <Dropdown.Item id = 'item' onClick={this.func}>
                                <Checkbox />
                                {s.text}
                            </Dropdown.Item>
                        )
                        )
                    }
                </Dropdown.Menu>
          
            </Dropdown>
        );
    }
}

export {MultiDropdown};


// WEBPACK FOOTER //
// ./src/components/PanelPages/MultiDropdown.jsx